<template>
  <div class="purchase-detail-box">
    <v-title
      title="我的拜访"
      :isShowBack="true"
      :isDefaultBack="false"
      @backHandle="goBack()"
    >
    </v-title>
    <div class="purchase-header">
      <div class="noRecord" v-if="noRecord">
        暂无记录
      </div>
      <div v-loading="loading" class="purchase-header-list" v-for="item in clientList" :key="item.clinetName" @click="goDetail(item.recordId)">
        <div class="purchase-header-item clearfix">
          <div class="title">{{item.clientName}}</div>
          <span class="fl">{{item.lastVisitTime}}</span>
        </div>
        <div class="purchase-header-item clearfix">
          <span class="fl">产品1数：{{item.productQuantity}}</span>
          <span class="fr">产品2数：{{item.competitiveProductQuantity}}</span>
        </div>
      </div>
    </div>
    <custom-loading v-if="loading" :isMask="true"></custom-loading>
  </div>
</template>
<script>
import CustomLoading from '@/components/CustomLoading.vue'
import { getMyVisitRecord } from '@/api/clientVisit'
export default {
  name: 'myVisit',
  components: {
    CustomLoading
  },
  computed: {},
  created () {
    this.loading = true
    getMyVisitRecord().then((res) => {
      if (res.code === 1) {
        this.clientList = res.data
        if (res.data.length === 0) {
          this.noRecord = true
        }
      }
    }).finally(() => {
      this.loading = false
    })
  },
  data () {
    return {
      noRecord: false,
      loading: true,
      defaultAreaName: {},
      provinceList: [],
      prductModel: {},
      clientList: [],
      competitiveProductModel: {}
    }
  },

  filters: {
  },
  methods: {
    goDetail (recordId) {
      this.$router.push({
        name: 'visitDetail',
        query: {
          data: recordId
        }
      })
    },
    goBack () {
      // this.$router.push({name:'index'})
      this.$router.back()
    },
    // 回车事件
    submitHandle () {
      this.$emit('enter', this.keyword)
    },
    // 失去焦点时
    blurHandle () {
      this.$emit('blur', this.keyword)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/base/base.styl';

.purchase-detail-box {
  height: 100%;
  background: #efefef;
}

.purchase-header {
  padding-top: 110px;
  background: #efefef;

  .noRecord {
    padding-top: 10px
    background: #fff
    text-align: center
    height: 65px
    font-size: 30px;
  }
  .purchase-header-list {
    padding 10px 30px
    margin-bottom: 20px
    background: #fff;
    .title {
      font-size: 30px;
      color: #333;
      font-weight: bold;
    }
    .purchase-header-item {
      margin-top: 5px
      margin-top: 24px;
      color: #666;
      font-size: 26px;
    }
  }
}

.purchase-main {
  top 100px
  padding 32px
  padding-top 100px
  background: #fff
  .purchase-main-list {
    background: #fff;
    margin-top: 10px;

    .purchase-main-list-item {
      border-bottom: 1px solid #efefef;
      padding-bottom: 36px;
      padding-top: 26px;
      color: #666;
      line-height: 1;
      font-size: 26px;
    }
  }
}
</style>
